import React from "react";
import Table from "react-bootstrap/Table";
import BabyDetails from "./BabyDetails";

const BabyList = (props) => {
  const babies = props.babies;
  
  return (
    <>
      <h4 className="text-center">Baby Details</h4>

      <Table bordered className="border-dark">
        <thead >
          <tr >
            <td className="text-center"><u>Name</u></td>
            <td className="text-center"><u>Age</u></td>
            <td className="text-center"><u>Date of birth</u></td>
            <td className="text-center"><u>Diapers</u></td>
            <td className="text-center"><u>Formula</u></td>
            <td className="text-center"><u>Formula type</u></td>
            <td className="text-center"><u>Formula amount</u></td>
          </tr>
         
        </thead>
        {babies.map(
          ({ name, date_of_birth, diapers, formula, formula_type, formula_amount, id }, i) => (
            
            <BabyDetails
              deleteBaby={props.deleteBaby}
              key={i}
              id={id}
              name={name}
              diapers={diapers}
              formula={formula}
              date_of_birth={date_of_birth}
              formula_type={formula_type}
              formula_amount={formula_amount}
              currentUser={props.currentUser}
            />
            )
        )}
      </Table>
    </>
  );
};

export default BabyList;
